import { GLOBAL_FIELD_NAMES, STRENGTH_WEAKNESSES_NAMES } from '../../Sections/Global/form';
import { ol, ul } from '../helpers';

const COMPANY_STRENGTHS_INSTRUCTIONS = {
  [STRENGTH_WEAKNESSES_NAMES.TITLE]: {
    name: 'Сильні сторони',
    instruction:
      'Визначте ключові компетенції та ресурси, які дають перевагу на ринку. Підкресліть спеціалізовані навички, унікальні можливості та репутацію бренду.',
    exampleOne: ul([
      'Спеціалізована експертиза в проєктуванні та виробництві гусеничних тракторів для важких або вологих ґрунтів.',
      'Унікальна запатентована технологія безперервних гумових гусениць, що забезпечує відмінне зчеплення та плавність ходу.',
      'Сильна команда, що складається з досвідчених інженерів, аграрних спеціалістів та професіоналів галузі.',
    ]),
    exampleTwo: ul([
      'Безпечна платіжна система гарантує надійне проведення фінансових трансакцій у межах платформи.',
      'Ретельний процес відбору перекладачів забезпечує високу якість і надійність послуг.',
      'Віддана команда з експертизою в програмуванні, мовних послугах та підтримці клієнтів.',
    ]),
  },
};

const COMPANY_WEAKNESSES_INSTRUCTIONS = {
  [STRENGTH_WEAKNESSES_NAMES.TITLE]: {
    name: 'Слабкі сторони',
    instruction:
      'Визначте внутрішні обмеження та виклики компанії. Відкрито опишіть напрями, що потребують покращення: процеси, ресурси, навички. Зверніть увагу на відставання від галузевих стандартів, операційну неефективність та їхній вплив на результативність і конкурентоспроможність.',
    exampleOne: ul([
      'Залежність від однієї запатентованої технології як основи диференціації тракторів обмежує диверсифікацію продуктів.',
      'Складнощі з масштабуванням виробництва для задоволення зростаючого попиту через обмеження виробничих потужностей.',
      'Відсутність географічної диверсифікації та значна залежність від конкретного ринку або регіону для продажів.',
    ]),
    exampleTwo: ul([
      'Обмежена впізнаваність бренду та присутність на ринку порівняно з усталеними конкурентами.',
      'Залежність від сторонніх технологічних провайдерів для певних функцій платформи.',
      'Залежність від відносно невеликої команди може призводити до дефіциту ресурсів у періоди високого попиту.',
    ]),
  },
};

export const GLOBAL_INSTRUCTIONS = {
  [GLOBAL_FIELD_NAMES.COMPANY_NAME]: {
    name: 'Назва компанії',
    instruction:
      'Укажіть повну офіційну назву вашої компанії. Якщо компанія ще не зареєстрована, подбайте, щоб назва відображала бачення бренду.',
    exampleOne: 'Agrotech',
    exampleTwo: 'LanguageLab',
  },
  [GLOBAL_FIELD_NAMES.REGISTRATION_DATE]: {
    name: 'Дата реєстрації',
    instruction: 'Укажіть точну дату офіційної реєстрації компанії, включно з роком, місяцем і днем реєстрації.',
    exampleOne: '8.16.2001',
    exampleTwo: '3.15.2008',
  },
  [GLOBAL_FIELD_NAMES.ADDRESS]: {
    name: 'Адреса реєстрації',
    instruction:
      'Укажіть місто та країну, де офіційно зареєстрована ваша компанія. Надання точних даних полегшує юридичні запити та бізнес-операції.',
    exampleOne: 'вул. Сміт 89, м. Шарлотт, Каліфорнія, США',
    exampleTwo: 'вул. Тейлор 100, м. Шарлотт, Північна Кароліна, США',
  },
  [GLOBAL_FIELD_NAMES.COMPANY_BRIEF_DESCRIPTION]: {
    name: 'Короткий опис компанії',
    instruction:
      'Надайте стислий огляд компанії. Які унікальні аспекти вирізняють ваш бізнес на ринку? Опишіть ключові продукти або послуги, підкресливши інноваційність або конкурентні переваги. Згадайте важливі віхи розвитку та стратегічні партнерства.',
    exampleOne:
      'Agrotech виробляє потужні гусеничні трактори для важких або вологих ґрунтів. Їхній унікальний безперервний гусеничний дизайн забезпечує відмінне зчеплення та плавність ходу, мінімізуючи тиск на ґрунт і негативний вплив завдяки запатентованій гумовій поверхні. Пріоритезуючи продуктивність і екологічну відповідальність, компанія пропонує сучасні рішення для актуальних викликів агросектору.',
    exampleTwo:
      'LanguageLab — це платформа мовних послуг, що оптимізує глобальну комунікацію більш ніж 100 мовами. Компанія дає змогу клієнтам і перекладачам покращувати свій досвід комунікації, забезпечуючи безперебійні процеси взаємодії.',
  },
  [GLOBAL_FIELD_NAMES.NUMBER_OF_EMPLOYEES]: {
    name: 'Кількість працівників',
    instruction:
      'Укажіть актуальну кількість працівників у компанії, включно зі штатними, позаштатними співробітниками та підрядниками.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.ANNUAL_INCOME]: {
    name: 'Середній річний дохід за минулі роки',
    instruction:
      'Розрахуйте та вкажіть середній річний дохід, підсумувавши загальний дохід за останні три роки та поділивши його на три. Це значення має бути точним і послідовно відображати фінансові результати за період.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION]: {
    name: 'Опис проєкту',
    instruction:
      'Стисло опишіть сутність інвестиційного проєкту — нове підприємство, модернізація чи розширення ринку. Коротко представте цільовий бізнес, його галузь, присутність на ринку, основні продукти, фінансовий стан і сильні сторони, пояснивши логіку інвестування чи придбання.',
    exampleOne:
      'Бізнес-план зосереджений на спеціалізованих гусеничних тракторах із запатентованою технологією безперервних гусениць, що вирішують проблему низької продуктивності на важких ґрунтах. Завдяки інноваціям трактори мають довший строк служби, знижують витрати та підвищують рентабельність для фермерів у довгостроковій перспективі.',
    exampleTwo:
      'Компанія вирішує проблему децентралізації ринку перекладів за допомогою централізованої платформи, ретельного відбору виконавців, безпечних платежів та технологій на базі AI. Наша стратегія використовує технології для оптимізації процесів, покращуючи комунікацію, ефективність і довіру між усіма учасниками.',
  },
  [GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES]: {
    name: 'Основні продукти/послуги',
    instruction:
      'Надайте структурований перелік ваших продуктів або послуг. Згрупуйте їх за категоріями або підкресліть флагманські рішення, що визначають ваш бізнес. Виділіть ключові характеристики, які відрізняють ваші продукти чи послуги від конкурентів: інноваційність, якість, унікальні властивості.',
    exampleOne:
      'Компанія спеціалізується на виробництві потужних гусеничних тракторів, розроблених для важких або вологих ґрунтів. Продукти включають:' +
      ol(['Гусеничні трактори', 'Сільськогосподарське обладнання', 'Екологічні рішення']),
    exampleTwo:
      'Компанія пропонує низку продуктів і послуг, спрямованих на оптимізацію глобальної комунікації та процесів взаємодії. До пропозицій входять:' +
      ol([
        'Послуги перекладу',
        'Інструменти перекладу на базі AI',
        'Рішення для оптимізації комунікації',
        'Інноваційні технологічні рішення',
      ]),
  },
  [GLOBAL_FIELD_NAMES.COMPANY_SECTOR]: {
    name: 'Сектор діяльності',
    instruction:
      'Укажіть сектор, у якому працює ваша компанія, обравши відповідний рівень деталізації з доступних варіантів у випадаючому списку.',
  },
  [GLOBAL_FIELD_NAMES.COMPANY_SUB_SECTOR]: {
    name: 'Підсектор діяльності',
    instruction:
      'Укажіть підсектор, у якому працює ваша компанія, обравши відповідний рівень деталізації з доступних варіантів у випадаючому списку.',
  },
  [GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY_GROUP]: {
    name: 'Галузева група діяльності',
    instruction:
      'Укажіть галузеву групу, у якій працює ваша компанія, обравши відповідний рівень деталізації з доступних варіантів у випадаючому списку.',
  },
  [GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY]: {
    name: 'Галузь діяльності',
    instruction:
      'Укажіть галузь, у якій працює ваша компанія, обравши відповідний рівень деталізації з доступних варіантів у випадаючому списку.',
    exampleOne: 'Виробництво сільськогосподарської техніки та обладнання.',
    exampleTwo: 'Послуги перекладу та усного тлумачення.\n Вебпортали пошуку та інші інформаційні послуги.',
  },
  [GLOBAL_FIELD_NAMES.MAIN_GOALS]: {
    name: 'Основні цілі та завдання',
    instruction:
      'Опишіть стратегічні цілі компанії, підкресливши коротко-, середньо- та довгострокові завдання, узгоджені з місією та баченням. Укажіть ключові напрями, такі як розширення ринку, зростання доходів чи інновації продуктів. Опишіть стратегії, ініціативи та KPI, що підтримують досягнення цих цілей.',
    exampleOne:
      'Довгострокова ціль: досягти лідерства на глобальному ринку шляхом диверсифікації продуктів, інвестування в R&D для сталих агротехнологій і виходу на ринки, що розвиваються. KPI включають частку ринку та рівень задоволеності клієнтів.',
    exampleTwo:
      'Короткострокова ціль: покращити зручність платформи за рахунок нових функцій та збільшити базу користувачів через таргетовані маркетингові кампанії. KPI: показники залученості користувачів.',
  },
  [GLOBAL_FIELD_NAMES.STRATEGY_FOR_ACHIEVING_GOALS]: {
    name: 'Стратегія успіху проєкту',
    instruction:
      'Сформулюйте основні стовпи стратегії успіху: клієнтоорієнтованість, інновації, операційна досконалість. Деталізуйте тактики, такі як диференціація на ринку, інноваційність, ефективність, залучення клієнтів та адаптація до викликів. Наголосіть на безперервному вдосконаленні та гнучкості.',
    exampleOne:
      'Стратегія компанії щодо успіху в цьому проєкті ґрунтується на трьох ключових стовпах: інновації, ринкова диференціація та клієнтоорієнтованість. Компанія постійно інвестує в дослідження та розробки, щоб покращувати продукти та випереджати ринкові тренди.',
    exampleTwo:
      'Стратегія компанії зосереджена на інноваціях, клієнтоорієнтованості та гнучкості. Постійно вдосконалюючи продукти на основі відгуків ринку, пріоритезуючи задоволеність клієнтів і швидко адаптуючись до галузевих тенденцій, компанія прагне до сталого зростання та лідерства в сегменті мовних послуг.',
  },
  [GLOBAL_FIELD_NAMES.TARGET_MARKET]: {
    name: 'Цільовий ринок і споживання ',
    instruction:
      'Надайте стислий огляд цільового ринку: потреби, уподобання, проблеми, які вирішує ваш продукт. Підкресліть унікальні аспекти, зокрема географічну концентрацію. Оцініть розмір ринку, посилаючись на джерела. Поясніть економічну цінність і бізнес-можливості.',
    exampleOne:
      'Цільовий ринок гусеничних тракторів компанії включає різні аграрні суб’єкти: малі фермерські господарства, середні підприємства та великі комерційні агрохолдинги в різних регіонах. Річне споживання в межах цільового ринку становить $100 млн.',
    exampleTwo:
      'Цільовий ринок компанії включає бізнеси та фізичних осіб із потребами в глобальній комунікації: транснаціональні корпорації, міжнародні організації, постачальники мовних послуг та особи, які потребують перекладу. Розмір річного споживання становить $49,6 млрд.',
  },
  [GLOBAL_FIELD_NAMES.TARGET_AUDIENCE]: {
    name: 'Цільова аудиторія',
    instruction:
      'Визначте цільову аудиторію: демографія, психологічні характеристики, потреби. Підкресліть відповідність продукту/послуги цим потребам. Виділіть унікальні характеристики: географія, галузь, поведінкові особливості.',
    exampleOne:
      'Цільова аудиторія охоплює різних учасників аграрного сектору, включно з фермерами, сільськогосподарськими кооперативами та агробізнесами. Вони формують основу глобального виробництва продуктів харчування та представляють різні напрями: польові культури, спеціальні культури, тваринництво й садівництво.',
    exampleTwo:
      'Цільова аудиторія включає бізнеси, організації та фізичних осіб із різноманітними мовними потребами. Основні типи клієнтів: транснаціональні корпорації, державні органи, міжнародні НУО, постачальники мовних послуг, навчальні заклади та окремі користувачі для особистих чи професійних перекладацьких запитів.',
  },
  [GLOBAL_FIELD_NAMES.TARGET_CHANNELS]: {
    name: 'Канали збуту',
    instruction:
      'Опишіть основні канали дистрибуції: прямі продажі, роздріб, e-commerce. Обґрунтуйте вибір, беручи до уваги охоплення, уподобання клієнтів та галузеві стандарти. Вкажіть переваги й виклики кожного каналу.',
    exampleOne: ol([
      'Мережа дилерів і дистриб’юторів: компанія співпрацює з дилерами та дистриб’юторами по всьому світу для продажу гусеничних тракторів.',
      'Прямі продажі: компанія має власну команду продажів, що працює з клієнтами, надає інформацію про продукти та супроводжує угоди.',
    ]),
    exampleTwo:
      'Компанія реалізує послуги через різні канали, включно з онлайн-платформою, командами прямих продажів, партнерствами з постачальниками мовних послуг, партнерськими програмами та участю в галузевих заходах і конференціях. Додатково використовуються цифрові маркетингові стратегії, зокрема соціальні мережі та e-mail-кампанії.',
  },
  [GLOBAL_FIELD_NAMES.MAIN_COMPETITORS]: {
    name: 'Основні конкуренти',
    instruction:
      'Проаналізуйте конкурентне середовище: основні конкуренти, частка ринку, пропозиції, охоплення. Опишіть відмінні характеристики чи переваги.',
    exampleOne:
      'Основними конкурентами компанії на ринку сільськогосподарської техніки є глобальні гравці, такі як Компанія X та Компанія Y, а також регіональні виробники, наприклад Компанія Z. Вони пропонують різні трактори та сільськогосподарське обладнання з передовими характеристиками й технологіями, напряму конкуруючи з гусеничними тракторами компанії за продуктивністю та інноваційністю.',
    exampleTwo:
      'Основними конкурентами компанії є відомі постачальники мовних послуг, такі як Компанія А, Компанія Б та Компанія В, а також нові гравці в сегменті мовних технологій, зокрема Компанія Г та Компанія Д. Ці компанії пропонують подібні послуги перекладу та рішення на базі ШІ для задоволення глобальних комунікаційних потреб.',
  },
  [GLOBAL_FIELD_NAMES.PROJECTED_ANNUAL_INCOME]: {
    name: 'Прогнозований річний дохід',
    instruction:
      'Розрахуйте прогнозований середній річний дохід, підсумувавши очікувані річні доходи за наступні три роки та поділивши суму на три. Використайте формулу:\n\nСередній прогнозований річний дохід =\n(Дохід 1-го року + Дохід 2-го року + Дохід 3-го року) / 3\n\nНадайте прогнозований дохід для кожного року та обґрунтуйте припущення з огляду на ринкові тренди, прогнози продажів та інші релевантні чинники.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.FORECASTED_PROFITABILITY]: {
    name: 'Прогнозована рентабельність',
    instruction:
      'Щоб розрахувати прогнозовану рентабельність у відсотках:' +
      ol([
        'Оцініть майбутній чистий прибуток.',
        'Спрогнозуйте загальний дохід.',
        'Поділіть чистий прибуток на загальний дохід.',
        'Помножте результат на 100, щоб отримати значення у відсотках.',
      ]) +
      'Використовуйте формулу: (Чистий прибуток / Загальний дохід) * 100 = Прогнозована рентабельність (%).',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.PROJECT_PAYBACK_PERIOD]: {
    name: 'Прогнозований строк окупності проєкту',
    instruction:
      'Щоб розрахувати прогнозований строк окупності на основі прибутку:' +
      ol([
        'Визначте загальний початковий обсяг інвестицій.',
        'Спрогнозуйте річний чистий прибуток.',
        'Поділіть загальні початкові інвестиції на річний чистий прибуток.',
        'Переведіть результат у місяці, помноживши на 12.',
      ]) +
      'Використовуйте формулу: Строк окупності =\n(Загальний обсяг початкових інвестицій / Річний чистий прибуток) * 12',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.TOTAL_COST]: {
    name: 'Загальна вартість проєкту',
    instruction:
      'Проведіть ретельну оцінку запланованих витрат. Комплексний бюджет має охоплювати різні аспекти: операційні витрати, капітальні інвестиції, маркетингові активності, технологічні вкладення та витрати на персонал.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.FUNDING_AMOUNT]: {
    name: 'Потреба у фінансуванні',
    instruction:
      'Визначте необхідний обсяг фінансування, провівши всебічну оцінку всіх витрат і запланованих видатків за проєктом.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING]: {
    name: 'Частка фінансування власними коштами',
    instruction: 'Укажіть відсоток вартості проєкту, що фінансуватиметься за рахунок власних коштів.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.MISSION]: {
    name: 'Місія компанії',
    instruction:
      'Сформулюйте місію компанії, визначивши її призначення та цінності. Підкресліть вплив на ринок або суспільство, наголосивши на унікальній ціннісній пропозиції. Узгодьте місію з ширшими цілями та покажіть відданість принципам, таким як інновації, сервіс чи сталий розвиток.',
    exampleOne:
      'Місія компанії — розробляти передові тракторні рішення, засновані на сталому розвитку та технологічних інноваціях, обслуговуючи глобальну аграрну спільноту.',
    exampleTwo:
      'Місія компанії — долати мовні бар’єри та зміцнювати глобальні зв’язки, надаючи безперебійні, високоякісні послуги перекладу завдяки інноваційним технологіям та винятковому рівню сервісу.',
  },
  [GLOBAL_FIELD_NAMES.COMPANY_STRENGTHS]: COMPANY_STRENGTHS_INSTRUCTIONS,
  [GLOBAL_FIELD_NAMES.COMPANY_WEAKNESSES]: COMPANY_WEAKNESSES_INSTRUCTIONS,
  [GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE]: {
    name: 'Унікальні особливості або конкурентна перевага',
    instruction:
      'Почніть із «гачка» або захопливої фрази, щоб привернути увагу читача. Чітко сформулюйте основне призначення або функцію продукту. Виділіть одну-дві ключові особливості, які відрізняють його від аналогів на ринку.',
    exampleOne:
      'Гусеничні трактори вирізняються інноваційним дизайном безперервних гусениць, що суттєво відрізняє їх від традиційних колісних тракторів. Ця конструкція забезпечує неперевершене зчеплення та плавність руху, що особливо важливо на важких або вологих ґрунтах. Додатково, запатентоване гумове покриття гусениць зменшує тиск на ґрунт і пошкодження культур, мінімізуючи ущільнення.',
    exampleTwo: ol([
      'Власні технології: платформа використовує передові внутрішні AI-рішення, що забезпечують конкурентну перевагу в ефективності, точності та інноваційності.',
      'Широка мовна підтримка: понад 100 мов дають змогу задовольнити різноманітні мовні потреби та пропонують клієнтам безпрецедентний доступ до глобальних комунікаційних каналів.',
    ]),
  },
  [GLOBAL_FIELD_NAMES.PRODUCT_DEVELOPMENT_PLANS]: {
    name: 'Плани розвитку продукту/послуги',
    instruction:
      'Сформулюйте стратегічне бачення організації щодо розвитку продуктів і розширення лінійки, описавши майбутні дослідницькі ініціативи та потенційні нові продуктові категорії чи сектори.',
    exampleOne:
      'Плани щодо розробки нових продуктів включають розробку низку передового обладнання для гусеничних тракторів, щоб підвищити їхню універсальність і продуктивність у різних видах робіт — від обробки ґрунту до збирання врожаю.',
    exampleTwo:
      'Мультимодальні послуги перекладу: розробка сервісів, що підтримують переклад у кількох форматах — текст, мовлення, зображення та відео — для надання більш комплексних мовних рішень.',
  },
  [GLOBAL_FIELD_NAMES.LOAN_BORROW_AMOUNT]: {
    name: 'Запланований обсяг кредиту',
    instruction:
      'Опишіть розмір кредиту та логіку його залучення. Обґрунтуйте необхідність позики з огляду на економічну доцільність, можливості для зростання та потребу зберігати фінансову гнучкість для стабільності й розвитку.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.INVESTMENT_AMOUNT]: {
    name: 'Запланований обсяг інвестицій',
    instruction:
      'Укажіть обсяг інвестицій і логіку їх залучення. Обґрунтуйте потребу в інвестиціях на основі можливостей зростання, ринкового попиту та стратегічних цілей, спрямованих на підвищення вартості та конкурентоспроможності компанії.',
    exampleOne: '',
    exampleTwo: '',
  },

  [GLOBAL_FIELD_NAMES.REVENUE_STREAMS]: {
    name: 'Бізнес-модель',
    instruction:
      'Окресліть основні джерела доходу, такі як продаж товарів, передплата або послуги. Узагальніть критичні фінансові припущення, включаючи ціноутворення, темпи зростання та ринковий попит. Перелічіть ключових партнерів, виділяючи їхню роль у підтримці бізнес-операцій та зростанні.',
    exampleOne:
      "Наші основні потоки доходів включають прямі продажі продуктових ліній, послуги на основі передплати та стратегічне партнерство для кобрендингових пропозицій. Ми прогнозуємо зростання виручки на основі ринкових тенденцій, припускаючи стабільне збільшення кількості клієнтів. Припущення щодо витрат включають стабільні виробничі витрати та поступове зростання маркетингових витрат. Наші ключові партнери включають постачальників сировини, дистриб'юторів для охоплення ринку та технологічних провайдерів для підтримки платформи. Співпраця з цими партнерами зміцнює наш ланцюжок створення вартості та розширює присутність на ринку.",
    exampleTwo:
      'Наші основні джерела доходу охоплюють продаж продукції через платформи електронної комерції, ліцензійні збори за власне програмне забезпечення та консультаційні послуги, адаптовані до потреб клієнтів. Прогнози доходів залежать від еластичності ринкового попиту, з консервативними оцінками, що враховують сезонні коливання. Припущення щодо витрат пріоритезують операційну ефективність та масштабованість, передбачаючи контрольоване зростання видатків. Стратегічні альянси з виробниками забезпечують стабільність ланцюжка постачань, тоді як цифрові маркетингові агенції підвищують впізнаваність бренду.',
  },
  [GLOBAL_FIELD_NAMES.MARKETING_STRATEGY]: {
    name: 'Стратегія продажів',
    instruction:
      'Опишіть ключові методи, які ви використовуватимете для залучення та утримання клієнтів, такі як канали реклами, стратегії ціноутворення та промо-заходи. Додатково включіть ваш підхід до продажів, детально описавши канали збуту, цільові ринки та плани продажів.',
    exampleOne: ol([
      "Мережа дилерів та дистриб'юторів: Компанія співпрацює з дилерськими центрами та дистриб'юторами по всьому світу для продажу своїх гусеничних тракторів.",
      'Прямі продажі: Компанія утримує власну команду прямих продажів, яка відповідає за взаємодію з клієнтами, надання інформації про продукт та супровід торгових операцій.',
    ]),
    exampleTwo:
      'Компанія реалізує свої послуги через різні канали, включаючи онлайн-платформу, команди прямих продажів, партнерство з постачальниками лінгвістичних послуг, партнерські програми та участь у галузевих заходах і конференціях. Крім того, компанія використовує стратегії цифрового маркетингу, такі як соціальні мережі та email-розсилки.',
  },
};
